var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06635 4.82428C8.60079 4.84451 9.02784 5.28416 9.02784 5.82355V10.6075C9.02784 11.1598 8.58013 11.6075 8.02784 11.6075H1.97211C1.41982 11.6075 0.972107 11.1598 0.972107 10.6075V5.82355C0.972107 5.27126 1.41982 4.82355 1.97211 4.82355H2.06635V3.39239C2.06635 1.73554 3.40949 0.392395 5.06635 0.392395C6.7232 0.392395 8.06635 1.73554 8.06635 3.39239V4.82428ZM7.06635 4.82355V3.39239C7.06635 2.28783 6.17091 1.3924 5.06635 1.3924C3.96178 1.3924 3.06635 2.28783 3.06635 3.39239V4.82355H7.06635Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.92c4b0bbb4f970c748117da8592c462e.svg";
export { ForwardRef as ReactComponent };